import { Routes } from '@angular/router';

import { seoResolver } from './core/resolvers/seo.resolver';
import { JADHU_SEO } from './shared/configs';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
    title: JADHU_SEO.home.title,
    resolve: {
      seo: seoResolver,
    },
    data: {
      seo: JADHU_SEO.home,
    },
  },

  {
    path: 'how-it-works',
    loadComponent: () => import('./pages/how-it-works/how-it-works.component').then(m => m.HowItWorksComponent),
    title: JADHU_SEO.howItWorks.title,
    resolve: {
      seo: seoResolver,
    },
    data: {
      seo: JADHU_SEO.howItWorks,
    },
  },

  {
    path: 'science',
    loadComponent: () => import('./pages/science/science.component').then(m => m.ScienceComponent),
    title: JADHU_SEO.science.title,
    resolve: {
      seo: seoResolver,
    },
    data: {
      seo: JADHU_SEO.science,
    },
  },

  {
    path: 'roadmap',
    loadComponent: () => import('./pages/roadmap/roadmap.component').then(m => m.RoadmapComponent),
    title: JADHU_SEO.roadmap.title,
    resolve: {
      seo: seoResolver,
    },
    data: {
      seo: JADHU_SEO.roadmap,
    },
  },

  {
    path: 'faq',
    loadComponent: () => import('./pages/faq/faq.component').then(m => m.FaqComponent),
    title: JADHU_SEO.faq.title,
    resolve: {
      seo: seoResolver,
    },
    data: {
      seo: JADHU_SEO.faq,
    },
  },

  {
    path: 'for-clinics',
    loadComponent: () => import('./pages/for-clinics/for-clinics.component').then(m => m.ForClinicsComponent),
    title: JADHU_SEO.clinics.title,
    resolve: {
      seo: seoResolver,
    },
    data: {
      seo: JADHU_SEO.clinics,
    },
  },

  {
    path: 'pricing',
    loadComponent: () => import('./pages/pricing/pricing.component').then(m => m.PricingComponent),
    title: JADHU_SEO.pricing.title,
    resolve: {
      seo: seoResolver,
    },
    data: {
      seo: JADHU_SEO.pricing,
    },
  },

  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
  },


  {
    path: 'terms-and-conditions',
    loadComponent: () => import('./pages/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent),
  },

  {
    path: 'compatibility',
    loadComponent: () => import('./pages/compatibility/compatibility.component').then(m => m.CompatibilityComponent),
  },

  {
    path: '**',
    redirectTo: '/',
  }
];
